import Svg from 'components/utilities/svg'

const DocumentIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Document Icon</title>
    <path d="M8,18 L16,18 L16,16 L8,16 L8,18 Z M8,14 L16,14 L16,12 L8,12 L8,14 Z M6,22 C5.45,22 4.97933333,21.8043333 4.588,21.413 C4.196,21.021 4,20.55 4,20 L4,4 C4,3.45 4.196,2.979 4.588,2.587 C4.97933333,2.19566667 5.45,2 6,2 L14,2 L20,8 L20,20 C20,20.55 19.8043333,21.021 19.413,21.413 C19.021,21.8043333 18.55,22 18,22 L6,22 Z M13,9 L18,9 L13,4 L13,9 Z" />
  </Svg>
)

DocumentIcon.displayName = 'Document'

export default DocumentIcon
